import { Skeleton } from "@/shared/ui";

export default function NotificationItemSkeleton() {
  return (
    <div className="mx-2 not-last:mb-1 p-3 flex gap-3 items-start">
      <div className="shrink-0">
        <Skeleton width={40} height={40} borderRadius={12} />
      </div>
      <div className="flex-1 min-w-0 flex flex-col gap-1.5 pt-0.5">
        <div className="flex items-center justify-between gap-2">
          <Skeleton width={140} height={14} />
          <Skeleton width={40} height={12} />
        </div>
        <Skeleton height={12} count={2} />
      </div>
    </div>
  );
}
